import {createResourcesProxy, waitForCSS} from '@parcel/runtime-rsc/rsc-helpers';
let promise = Promise.all([parcelRequire.load("63IPP")]).then(() => {
let originalModule = parcelRequire("95QG0");
let resources = <link rel="modulepreload" href={parcelRequire.resolve("63IPP")} />;
let res = createResourcesProxy(originalModule, false, resources );
  return res;
});
module.exports = promise;
